export const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  zipCodeKey: process.env.REACT_APP_ZIPCODE_KEY
}
export const nextStepDelayTime = 50;
export const currentBankDurationOptionsMap = {
  "1 - 3 month": 3,
  "3 - 6 months": 6,
  "7 - 12 months": 12,
  "1 - 2 year": 24,
  "More than 2 years": 30,
}
export const currentCompanyDurationOptionsMap = {
  "5 years or more": 60,
  "3 - 4 years": 48,
  "1 - 2 years": 24,
  "3 - 12 months": 12,
  "3 months or less": 3
}
export const contactKeysMap = {
  bankAccount: 'bank_account_number',
  bankAccountType: 'bank_account_type',
  bankName: 'bank_name',
  bestTimeContact: 'contact_time',
  city: 'city',
  createdAt: 'created_at',
  creditScoreRating: 'credit_score',
  currentBankDuration: 'bank_account_length_month',
  currentCompanyDuration: 'work_time_at_employer',
  currentResidenceDuration: 'time_at_residence',
  dob: 'dob',
  email: 'email',
  employerName: 'work_company_name',
  employerPhone: 'work_phone',
  firstName: 'first_name',
  getDirectDeposit: 'bank_direct_deposit',
  incomeSource: 'income_type',
  ipAddress: 'user_ip',
  issuingState: 'drivers_license_state',
  jobTitle: 'job_title',
  lastName: 'last_name',
  licenseID: 'drivers_license_number',
  loanReason: 'loan_reason',
  amount: 'loan_amount',
  monthlyIncome: 'income_net_monthly',
  incomeNextDate1: 'income_next_date_1',
  incomeNextDate2: 'income_next_date_2',
  ownCar: 'own_car',
  incomePaymentFrequency: 'income_payment_frequency',
  phone: 'home_phone',
  residenceOwnership: 'own_home',
  routingNumber: 'bank_aba',
  socialSecurityNumber: 'ssn',
  state: 'state',
  streetAddress: 'address',
  testMode: 'test_mode',
  unsecuredDebtAmount: 'debt_amount',
  updatedAt: 'updated_at',
  userAgent: 'user_agent',
  zipCode: 'zip'
}
export const reversedContactKeysMap = () => {
  const maps = {}
  for(const key in contactKeysMap) {
    maps[contactKeysMap[key]] = key
  }
  return maps
}
export const phonePattern = /(\((?!0|1)\d{3}\)-\d{3}-\d{4})|((?!0|1)\d{3}\d{3}\d{4})/

export const partners = {
  "AlumAds": null,
  "Solution BPO": null,
  "X1 Info Tech": null,
  "JG Wentworth": null,
  "Stop Go Networks": null,
  "Dot818": null,
  "Lead Network": null,
  "Round Sky": null,
  "Leap Theory": null,
  "Teapot": null,
  "ITMEDIA": null,
  "LeadsMarket": null,
  "PingLogix": null,
  "UpAds": null,
  "Intimate Interactive": null,
  "Teapot Media": null,
  "Leadtree Global": null,
  "Interlincx Media": null,
  "Freshway Media": null,
  "Lead Avenue": null,
  "Affilic Digital": null,
  "Boomsourcing": null,
  "Tradition Media Group": null,
  // "MaxCash": null,
  "Big Step Marketing": null,
  "Reliable Leads": null,
  "RevJolt": null,
  "Complete Home Services": null,
  "Insurance Guide": null,
  "National Association of Chiefs of Police": null,
  "Autistic Children of America": null,
  "ITP": null,
  "Infinity One": null,
  "Quinstreet": null,
  "Cane Bay": null,
  "Gulf Coast Leads": null,
  "Media Blanket": null,
  "Liftup Capital": null,
  "UniFi Funding": null,
  "AAA Auto Title Loans, LLC": null,
  "CASH 1, LLC (NV)": null,
  "CASH 1 UT, LLC": null,
  "CASH 1 ID, LLC": null,
  "CASH 1 KS, LLC": null,
  "CASH 1 MO, LLC": null,
  "CASH 1 LA, LLC": null,
  "ArcaMax Publishing": null,
}

export const stepOrder = [
  "lgname",
  "email",
  "cellphone",
  "zip",
  "address",
  "hometime",
  "ownhome",
  "incomesource",
  "emptime",
  "unsecureddebtamount",
  "payfreequency",
  "grossincome",
  "nextpaydate",
  "empinfor",
  "workphone",
  "deposit",
  "aba",
  "banktype",
  "banktime",
  "bankaccount",
  "driverid",
  "owncar",
  "creditscore",
  "ssn"
]
